module.exports = __webpack_public_path__ + "static/media/sproutScreenshot.bd4546ef.png";